import { setOpenLocationSelectionModal } from '@/store/modal';
import { openSearchModal, SearchModalOpenContext, setPreselectedFilter } from '@/store/search/search.store';
import { PersistedUserNavigationSearchParams } from '@/types/enums/persisted-user-navigation-search-params.enum';
import { SearchResultsFilter } from '@/types/search-results-filter.type';

interface HandleOpenSearchModalProps extends SearchModalOpenContext {
  searchTerm?: string | undefined;
  skipLocationModal?: boolean;
  preselectedFilter?: SearchResultsFilter;
  openAfterLocationSelection?: boolean;
}

export function handleOpenSearchModal({
  searchTerm,
  skipLocationModal,
  origin,
  originCategory,
  preselectedFilter,
  openAfterLocationSelection = false,
}: HandleOpenSearchModalProps = {}) {
  const searchParams = new URLSearchParams(window.location.search);
  const city = searchParams.get(PersistedUserNavigationSearchParams.CIDADE);

  if (city || skipLocationModal) {
    setPreselectedFilter(preselectedFilter);
    openSearchModal(true, searchTerm, { origin, originCategory, term: searchTerm });
  } else {
    if (searchTerm) {
      setOpenLocationSelectionModal(true, {
        shouldOpenSearchModal: false,
        pendingSearchTerm: searchTerm,
        pendingSearchContext: { origin, originCategory, term: searchTerm },
      });
    } else {
      setOpenLocationSelectionModal(true, {
        shouldOpenSearchModal: openAfterLocationSelection,
        pendingSearchContext: { origin, originCategory },
      });
    }
  }
}
